<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    isOnExpandedLayout: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle'],
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<template>
  <!-- Rosh whitelabel: era um botão xs/faded que passava despercebido. Agora é
       um controle visível de "modo foco" (recolhe a lista de conversas). -->
  <NextButton
    v-tooltip.left="$t('CONVERSATION.SWITCH_VIEW_LAYOUT')"
    :icon="
      isOnExpandedLayout
        ? 'i-lucide-panel-left-open'
        : 'i-lucide-panel-left-close'
    "
    slate
    sm
    outline
    class="flex-shrink-0 rtl:rotate-180 ltr:rotate-0 md:inline-flex hidden !text-n-slate-11 hover:!text-n-slate-12"
    @click="toggle"
  />
</template>
